import React from 'react';
import { FaStar, FaStarHalfAlt, FaRegStar } from 'react-icons/fa';
import PropTypes from 'prop-types';
import './StarRating.css';

const StarRating = ({ rating = 0, color = '#f1c40f', size = 16 }) => {
  // Ensure rating is between 0 and 5
  const clampedRating = Math.min(5, Math.max(0, rating));
  const fullStars = Math.floor(clampedRating);
  const hasHalfStar = clampedRating % 1 >= 0.5;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  return (
    <div className="star-rating" aria-label={`Rating: ${clampedRating} out of 5 stars`}>
      {[...Array(fullStars)].map((_, i) => (
        <FaStar 
          key={`full-${i}`} 
          className="star" 
          color={color} 
          size={size} 
          aria-hidden="true"
        />
      ))}
      
      {hasHalfStar && (
        <FaStarHalfAlt 
          key="half" 
          className="star" 
          color={color} 
          size={size} 
          aria-hidden="true"
        />
      )}
      
      {[...Array(emptyStars)].map((_, i) => (
        <FaRegStar 
          key={`empty-${i}`} 
          className="star" 
          color={color} 
          size={size} 
          aria-hidden="true"
        />
      ))}
    </div>
  );
};

StarRating.propTypes = {
  rating: PropTypes.number,
  color: PropTypes.string,
  size: PropTypes.number,
};

export default StarRating;